import { Injectable } from '@angular/core';
import {Space, User} from "../model/tenants.model";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {ObjectMapper} from "json-object-mapper";

@Injectable({
  providedIn: 'root'
})
export class TenantsManagerService {

  constructor(
    private http: HttpClient
  ) { }

  spaces() {
    let path = "/tenants/spaces"
    return this.http.get(environment.apiPrefix + path)
      .pipe(map(result => ObjectMapper.deserializeArray(Space, result)));
  }

  space(code: string) {
    let path = "/tenants/space/" + code;
    return this.http.get(environment.apiPrefix + path)
      .pipe(map(result => ObjectMapper.deserialize(Space, result)));
  }

  users(code: string) {
    let path = "/tenants/users/" + code;
    return this.http.get(environment.apiPrefix + path)
      .pipe(map(result => ObjectMapper.deserializeArray(User, result)));
  }
}
